/**
 * 루트 스트리밍 폴백.
 *
 * 종전에는 스피너 옆에 `로딩 중...` 텍스트 노드가 있었다. 이 폴백은 스트리밍 특성상
 * **완성된 페이지의 HTML 최상단에도 그대로 남아**, 크롤러가 본문에서 처음 만나는 문장이
 * `로딩 중...`이 됐다(실측: 522 상세 HTML 11,235바이트 지점). 스피너만으로도 로딩은
 * 충분히 전달되므로 문구는 `aria-label`로 옮겼다 — 화면은 그대로, 텍스트 노드만 사라진다.
 */
export default function Loading() {
  return (
    <div
      role="status"
      aria-label="로딩 중"
      className="absolute inset-0 bg-black/50 flex items-center justify-center z-[50]"
    >
      <div
        aria-hidden
        className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"
      />
    </div>
  );
}
